import BaseEulaField from 'registration/js/base/fields/eula';

import template from 'registration/templates/new/fields/eula.html';

const EulaField = BaseEulaField.extend({
    template
});

export default EulaField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/new/fields/eula.js